import { Icon } from '@types';

export const Location = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 76.93 68.39"
		>
			<defs>
				<style>
					{
						'.cls-location{stroke:#fff;}.cls-location,.cls-location-2{fill:#fff;}.cls-location,.cls-location-2,.cls-location-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-location-2,.cls-location-3{stroke:#2e2d2c;}.cls-location-3{fill:none;}'
					}
				</style>
			</defs>
			<g>
				<polygon
					className="cls-location-3"
					points="75.93 67.39 1 67.39 14.42 46.73 62.51 46.73 75.93 67.39"
				/>
				<g>
					<path
						className="cls-location"
						d="M57.32,19.85c0-12.89-12.94-22.76-26.54-17.33-4.44,1.77-7.85,5.26-9.64,9.69-2.52,6.26-1.75,12.3,1.01,17.06h-.01l14.24,24.66c.93,1.61,3.26,1.61,4.19,0l14.24-24.66h-.01c1.61-2.78,2.54-5.99,2.54-9.43Z"
					/>
					<path
						className="cls-location-2"
						d="M57.32,19.85c0-12.89-12.94-22.76-26.54-17.33-4.44,1.77-7.85,5.26-9.64,9.69-2.52,6.26-1.75,12.3,1.01,17.06h-.01l14.24,24.66c.93,1.61,3.26,1.61,4.19,0l14.24-24.66h-.01c1.61-2.78,2.54-5.99,2.54-9.43Z"
					/>
				</g>
			</g>
			<g>
				<polyline
					className="cls-location-3"
					points="45.4 22.06 45.4 30.81 31.52 30.81 31.52 22.06"
				/>
				<polyline className="cls-location-3" points="27.75 19.46 38.47 9.2 49.18 19.46" />
			</g>
		</svg>
	);
};
